/**
 * Tüm alan (domain) enum'ları tek kaynaktan gelir.
 * Veritabanı enum tipleri, TypeORM entity'leri, Joi şemaları ve istemciler
 * bu dosyayı referans alır. Buraya bir değer eklemek = migration gerektirir.
 */
export const LOCALES = ['tr', 'en'];
export const DEFAULT_LOCALE = 'tr';
/** Platform seviyesi rol. Organizasyon içi roller ayrıdır (OrganizationMemberRole). */
export const PLATFORM_ROLES = ['user', 'moderator', 'admin'];
/**
 * HESAP TÜRÜ (kullanıcı kararı 02.10.2026 · `docs/kurum-hesabi-2026-10-02.md`).
 *
 * Kurum işi AYRI hesapla yapılır (KH1): genel kayıt `personal` hesap açar,
 * kurum davetiyle kayıt `organization` hesap açar. Tür doğuşta yazılır ve
 * HİÇBİR yoldan değişmez (KH10): veritabanı tetikleyicisi güncellemeyi reddeder.
 * Kurum hesabı katılımcı yüzeylerine, kişisel hesap yönetim yüzeylerine
 * sunucuda giremez.
 */
export const ACCOUNT_KINDS = ['personal', 'organization'];
export const USER_STATUSES = ['pending', 'active', 'suspended', 'deleted'];
export const AUTH_PROVIDERS = ['email_otp', 'google', 'apple'];
/**
 * Profesyonel profil taksonomisi (Blok 8-1). Katılımcı listesi kıdem ve sektöre göre
 * FİLTRELENİR (tasarım ekran 6b) — bu yüzden serbest metin değil, kapalı liste.
 * Yeni değer eklemek migration gerektirir; etiketler i18n katmanından gelir
 * (`profile.seniority.*` / `profile.sector.*`), koda gömülmez.
 */
export const SENIORITY_LEVELS = [
    'student',
    'entry',
    'mid',
    'senior',
    'lead',
    'manager',
    'director',
    'executive',
    'founder',
    'freelance',
];
/** Sektör taksonomisi — ilgi etiketinden AYRIDIR (etiket ilgi alanı, sektör iş kolu). */
export const SECTORS = [
    'software',
    'telecom',
    'finance',
    'insurance',
    'healthcare',
    'pharma',
    'education',
    'research',
    'manufacturing',
    'automotive',
    'construction',
    'real_estate',
    'energy',
    'agriculture',
    'retail',
    'ecommerce',
    'logistics',
    'tourism',
    'food_beverage',
    'media',
    'marketing',
    'consulting',
    'legal',
    'public_sector',
    'ngo',
    'arts',
    'sports',
    'other',
];
export const ORGANIZATION_MEMBER_ROLES = ['owner', 'admin', 'editor', 'viewer'];
/**
 * `declined`: davet edilen kişi daveti reddetti. `removed`'dan ayrı tutulur —
 * organizatör "cevap gelmedi" ile "hayır dedi" arasını görmeli. İki durumda da
 * `removed_at` dolar: o kolon kısmi tekillik anahtarıdır, dolunca aynı kişi
 * yeniden davet edilebilir (Blok 4 kararı).
 */
export const ORGANIZATION_MEMBER_STATUSES = ['invited', 'active', 'removed', 'declined'];
/**
 * Kurumun nasıl doğduğu (kurum satışla açılır · Story C1). `panel`: personel
 * açtı, doğrulanmış doğdu. `self_serve`: kullanıcı açtı (bugün sunucu ayarıyla
 * kapalı yol). Mevcut satırlar migration'da `self_serve` aldı. `organizations.
 * provisioning_source` varchar + CHECK; pg enum değil (`organizations.plan` emsali).
 */
export const ORGANIZATION_PROVISIONING_SOURCES = ['self_serve', 'panel'];
export const ORGANIZATION_VERIFICATION_STATUSES = [
    'unverified',
    'pending',
    'verified',
    'rejected',
];
/** CLAUDE.md — erişim modu her etkinlikte zorunlu, varsayılanı yoktur. */
export const EVENT_ACCESS_MODES = ['public', 'approval', 'invite_only'];
export const EVENT_STATUSES = ['draft', 'published', 'cancelled', 'archived'];
export const EVENT_FORMATS = ['in_person', 'online', 'hybrid'];
/**
 * Etkinliği kim açtı. `shadow` (katılımcının açtığı gölge etkinlik) ürün modelinden
 * KALDIRILDI (Blok 8-1): yeni etkinlik yalnızca `organizer` doğar. Değer TARİHSEL
 * kayıtlar için enum'da kalır — migration'lar dondu ve mevcut satırlar okunabilir olmalı.
 */
export const EVENT_ORIGINS = ['organizer', 'shadow'];
export const TICKET_STATUSES = ['active', 'hidden', 'closed'];
export const ATTENDANCE_STATUSES = [
    'pending_approval',
    'registered',
    'waitlisted',
    'rejected',
    'cancelled',
    'attended',
];
/**
 * Öneri motorunun ihtiyaç duyduğu kaynak sinyali (Story 10.1).
 * `shadow_creation` KALDIRILDI (Blok 16): gölge etkinlik üründen çıktı, hiçbir
 * yazma yolu bu değeri üretmiyordu. DB enum'u da daraltıldı
 * (`Blok16NarrowAttendanceSource` migration'ı) — sözleşme ile şema ayrışmasın.
 */
export const ATTENDANCE_SOURCES = [
    'discovery',
    'direct_link',
    'invitation',
    'search',
    // Story 17.4 (Karar 2): etkinliği açan kişinin yayın anında oluşan kaydı.
    // İSTEMCİDEN GELEMEZ (`DIRECT_REGISTRATION_SOURCES` dışında) — yalnız yayın
    // akışı ve geriye dönük göç yazar.
    'organizer_auto',
];
export const ATTENDANCE_ROLES = ['attendee', 'speaker', 'staff', 'sponsor'];
export const INVITATION_STATUSES = [
    'sent',
    'opened',
    'accepted',
    'rejected',
    'expired',
    'revoked',
];
export const APPLICATION_STATUSES = ['submitted', 'approved', 'rejected', 'withdrawn'];
/**
 * Sahiplenme (claim) durum kümesi — karar S1 gereği EKSİKSİZ tanımlanmıştır.
 * Otomasyon Faz 4'te eklenecek; bu küme ve geçiş kuralları DEĞİŞMEYECEK.
 */
export const CLAIM_REQUEST_STATUSES = [
    'submitted',
    'evidence_added',
    'owner_notified',
    'objection_window',
    'objected',
    'approved',
    'rejected',
    'withdrawn',
    'transferred',
];
/** Kararı kim verdi: Faz 1'de admin, Faz 4'te system. Şema değişmez, değer değişir. */
export const CLAIM_DECIDED_BY_TYPES = ['admin', 'system'];
export const CLAIM_EVIDENCE_TYPES = [
    'corporate_email',
    'website_match',
    'document',
    'social_proof',
    'other',
];
export const SPEAKER_STATUSES = ['draft', 'published'];
/**
 * Konuşmacı ↔ kullanıcı bağlama onayı (Story 6.1). Bağlantı KULLANICI onaylayana
 * kadar kurulmaz; onaya kadar organizatörün girdiği bilgiler gösterilir.
 * Kullanıcı bağlantıyı istediği an kaldırabilir (`linked` → `none`).
 */
export const SPEAKER_USER_LINK_STATUSES = ['none', 'pending', 'linked'];
export const AGENDA_SESSION_TYPES = [
    'talk',
    'panel',
    'workshop',
    'break',
    'networking',
    'other',
];
/** Kırmızı çizgi 1: kart değişimi çift taraflı onaylıdır — durum bunu yansıtır. */
export const ENCOUNTER_STATUSES = ['pending', 'confirmed', 'declined', 'expired'];
export const ENCOUNTER_CHANNELS = ['qr', 'link', 'manual', 'nfc'];
/**
 * Kart değişimi TEKLİFİ (Blok 20). `encounters` ARTIK teklif tutmaz: teklifin
 * yaşam döngüsü — bekleme, ret, süre dolumu — bu tabloya taşındı, `encounters`
 * yalnızca İKİ ONAY tamamlandığında doğan kaydı taşır (D1/D3).
 */
export const CARD_EXCHANGE_STATUSES = [
    'pending',
    'confirmed',
    'declined',
    'expired',
    'cancelled',
];
/** Teklifin geldiği kanal. `manual_code` = kamera yokken elle girilen kısa kod. */
export const CARD_EXCHANGE_CHANNELS = ['qr', 'manual_code', 'link'];
export const MEETING_REQUEST_STATUSES = [
    'pending',
    'accepted',
    'declined',
    'cancelled',
    'expired',
];
export const SPONSOR_TIERS = ['platinum', 'gold', 'silver', 'bronze', 'partner'];
/** Rıza türleri — KVKK/GDPR denetimi bu kümeden beslenir. */
export const CONSENT_TYPES = [
    'terms_of_service',
    'privacy_policy',
    'kvkk_clarification',
    'marketing_email',
    'analytics',
    'attendee_visibility',
    /** Kurum hesabı aydınlatma metni (Story H5, V11): yalnız kurum hesabının rıza setinde. */
    'organization_account_notice',
];
export const CONSENT_STATUSES = ['granted', 'withdrawn'];
/** Bildirim sebebi (Story 11.1). `personal_data` KVKK yükümlülüğüyle öncelikli kuyruğa düşer. */
export const REPORT_REASONS = ['fake', 'spam', 'inappropriate', 'personal_data', 'other'];
/** Bildirilebilir hedefler (kuyruk kalemi de aynı tipleri kullanır); `announcement` Story 9. */
export const MODERATION_TARGET_TYPES = ['event', 'user', 'claim_request', 'announcement'];
/**
 * Moderasyon kuyruğu kalem tipi (Story 11.2) — GENİŞLETİLEBİLİR tanım:
 * sahiplenme talepleri (`claim`) bu kuyruğa claim modülünden düşer.
 */
export const MODERATION_ITEM_TYPES = ['report', 'suspicious_event', 'appeal', 'claim'];
export const MODERATION_ITEM_STATUSES = [
    'open',
    'info_requested',
    'resolved',
    'dismissed',
];
/** Kalem kuyruğa nereden düştü. Otomatik sinyaller KARAR VERMEZ, yalnızca kuyruğa taşır. */
export const MODERATION_SOURCES = ['user_report', 'auto_signal', 'system'];
export const MODERATION_PRIORITIES = ['normal', 'high'];
/** Admin kararı — her karar ZORUNLU gerekçeyle denetim kaydına yazılır. */
export const MODERATION_DECISIONS = ['approved', 'rejected', 'info_requested'];
/** Admin kullanıcı tablosu filtreleri (tasarım ekran 25). */
export const ADMIN_USER_FILTERS = ['all', 'organizers', 'flagged'];
export const AUDIT_ACTOR_TYPES = ['user', 'admin', 'system', 'anonymous'];
export const AUDIT_RESULTS = ['success', 'failure'];
export const MEDIA_ASSET_KINDS = [
    'user_avatar',
    'card_logo',
    'event_cover',
    'event_logo', // Story 23.1 — 240×80 marka bandı; kapak (`event_cover`) DEĞİL.
    'organization_logo',
    'organization_cover', // Kurum kapak görseli (14.10.2026) — geniş fotoğraf, logo DEĞİL.
    'speaker_photo',
    'sponsor_logo',
    'claim_document', // Story 3.5 — PDF yetki belgesi; türev üretilmez.
    'organization_document', // Karar 1 / Story 18.3 — PDF; 90 gün sonra silinir.
];
export const MEDIA_ASSET_STATUSES = [
    'pending',
    'uploaded',
    'processing',
    'ready',
    'failed',
    'deleted',
];
export const MEDIA_VARIANTS = ['thumbnail', 'detail', 'og'];
/**
 * Etiket yaşam döngüsü (Story 2.2): kullanıcı önerisi 'pending' doğar; admin
 * onaylarsa 'active', birleştirirse 'merged' olur. 'pending' etiket önerilen
 * kullanıcının profilinde görünür ama arama/öneri hesaplamasına girmez.
 */
export const INTEREST_TAG_STATUSES = ['active', 'pending', 'merged', 'deprecated'];
/** Kimlik akışında istemci türü — jeton saklama biçimini belirler (Story 1.1):
 * web'de HttpOnly çerez, mobilde güvenli depo. */
export const AUTH_CLIENTS = ['web', 'mobile'];
/**
 * Organizatörün seçili kayıtlara uygulayabildiği toplu işlemler (ekran 19).
 * `remove` YIKICIDIR: gerekçe zorunludur ve denetim kaydına yazılır.
 */
export const BULK_ATTENDEE_ACTIONS = ['remove', 'change_ticket'];
/**
 * Kapıda check-in girişinin nasıl yapıldığı (ekran 20). `badge_qr` yaka kartı
 * jetonunun okutulmasıdır; `manual` QR okunamayan katılımcı için görevlinin
 * listeden seçmesidir — ikisi de aynı kaydı üretir, ayrım denetim içindir.
 */
export const CHECK_IN_METHODS = ['badge_qr', 'manual'];
/** Üçüncü taraf kimlik sağlayıcıları (Story 1.2). E-posta OTP ayrı akıştır. */
export const OAUTH_PROVIDERS = ['google', 'apple'];
/**
 * Veri dışa aktarma işi (Story 8.3). `ready` işin çıktısı indirilebilir demektir;
 * bağlantı süresi dolunca `expired` olur ve içerik kalıcı temizlenir.
 */
export const DATA_EXPORT_STATUSES = ['queued', 'processing', 'ready', 'failed', 'expired'];
/** İndirilebilir biçimler — kırmızı çizgi 3: CSV (KVKK kopyası ZIP'inde bölüm başına) **ve** vCard zorunlu, JSON makine okunurluğu için. */
export const DATA_EXPORT_FORMATS = ['json', 'zip', 'vcard'];
/** Push cihaz platformu (Story 9.2 — `device_tokens.platform` DB enum'u). */
export const DEVICE_PLATFORMS = ['ios', 'android'];
/**
 * `GET /users/me/attendances` kulvar durumu (Blok 7A dikişi). DB enum'u DEĞİL:
 * katılım + başvuru kulvarlarından TÜRETİLİR. `invited` YOK (B-30, kullanıcı
 * kararı 09.10.2026): bekleyen davet katılım değildir, ayrı uçtan gelir
 * (`GET /users/me/event-invitations`); katılım sayan yüzey daveti DERLEMEDE sayamaz.
 */
export const MY_PARTICIPATION_STATUSES = [
    'registered',
    'applied',
    'waitlisted',
    'cancelled',
];
/** Bildirim tercihi türleri (Story 8.2). İşlemseller kilitlidir, nedeni ekranda açıklanır. */
export const NOTIFICATION_TYPES = [
    'event_update',
    'invitation',
    'application_result',
    'product_news',
    /**
     * Görüşme talebi (D5 — Blok 12). KİLİTLİDİR: talepler sessizce birikemez.
     * Talep ALMAYI kapatmak ayrı anahtardır (`users.meeting_requests_enabled`).
     */
    'meeting_request',
    /**
     * Kart degisimi (Blok 21 — Story 17.2/17.3). ISLEMSELDIR ve KILITLIDIR:
     * teklif 15 dakika yasar, karsi taraf yanindadir. RET bildirimi GONDERILMEZ
     * (ayirt edilemez ret): tur yalniz "teklif geldi" ve "tamamlandi" tasir.
     */
    'card_exchange',
    /**
     * Takip hatirlatmasi (Blok 23 — Story 18.2). KAPATILABILIR: kullanicinin
     * KENDI kurdugu hatirlatmadir; susturulunca kaybolan karsi taraf talebi yok.
     */
    'follow_up_reminder',
    /**
     * Yeni etkinlik ONERISI (bildirim merkezi — K4). KILITLI DEGILDIR; uygulama
     * ICI kayit tercihten BAGIMSIZ yazilir (K3), tercih yalniz kanali yonetir.
     */
    'recommendation',
    'followed_organization_event', // kurum takibi (A1: K3 istisnası, yalnız push)
    'organizer_announcement', // duyurular Story 2: kilitsiz, e-posta ve push ayrı kapanır
    'event_reminder', // belge ve anket Story 6: etkinlik sonrası iletisi, kilitsiz
];
export const NOTIFICATION_CHANNELS = ['email', 'push'];
/** Kapatılamayan (işlemsel) bildirim türleri. */
export const LOCKED_NOTIFICATION_TYPES = [
    'invitation',
    'application_result',
    'meeting_request',
    'card_exchange',
];
/** Oturum iptal nedeni — güvenlik olayları denetlenebilir kalır (Story 1.3). */
export const SESSION_REVOKE_REASONS = [
    'logout',
    'user_revoked',
    'revoked_all',
    'reuse_detected',
    'expired',
    'account_deleted',
];
// --- Öneri motoru (Blok 9-1) ------------------------------------------------
/**
 * Öneri türü. `event` = "sana önerilen etkinlik", `person` = belirli bir
 * etkinliğin İÇİNDE "kiminle tanışmalısın". İki tür aynı tabloda durur çünkü
 * okuma yolu, sıralaması ve gerekçe sözleşmesi ortaktır.
 */
export const RECOMMENDATION_KINDS = ['event', 'person'];
export const RECOMMENDATION_RUN_STATUSES = ['running', 'succeeded', 'failed'];
/**
 * Etiket yakınlığının kaynağı. `embedding` hazır (önceden eğitilmiş) vektörden
 * türetilmiştir; `taxonomy` etiket ağacındaki ebeveyn/kardeş ilişkisinden gelir.
 * Kaynak SAKLANIR ki "bu yakınlık nereden çıktı" sorusu yanıtlanabilsin.
 */
export const TAG_SIMILARITY_SOURCES = ['embedding', 'taxonomy'];
/**
 * Etkinlik ilgi sinyali türü (Story 10.2). `save` şema düzeyinde hazırdır ama
 * Faz 1'de kullanıcıya görünen "kaydet" özelliği YOKTUR — sonradan kolon
 * eklemek migration borcu üretirdi.
 */
export const EVENT_INTEREST_SIGNAL_KINDS = ['view', 'save'];
//# sourceMappingURL=enums.js.map